import { motion } from 'framer-motion';
import heroImg from '../assets/IMG_0494.jpg';
import styles from './Hero.module.css';

const WA = 'https://wa.me/918890469900?text=Hi%2C%20I%27d%20like%20to%20book%20an%20appointment%20at%20Shobha%20Salon';

export default function Hero() {
  return (
    <section id="hero" className={styles.hero}>
      {/* Real photo background */}
      <motion.div
        className={styles.bg}
        style={{ backgroundImage: `url(${heroImg})` }}
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2, ease: [0.25, 0.46, 0.45, 0.94] }}
      />
      <div className={styles.overlay} />
      <div className={styles.grain} aria-hidden="true" />

      {/* Decorative side lines */}
      <div className={styles.sideLineLeft} aria-hidden="true" />
      <div className={styles.sideLineRight} aria-hidden="true" />

      <div className={styles.content}>
        {/* Script accent */}
        <motion.div
          className={styles.scriptAccent}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          Shobha Salon
        </motion.div>

        {/* Eyebrow */}
        <motion.div
          className={styles.eyebrow}
          initial={{ opacity: 0, scaleX: 0.6 }}
          animate={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 0.9, delay: 0.5 }}
        >
          <span className={styles.rule} />
          <span className={styles.eyebrowText}>Est. 2000 &nbsp;·&nbsp; Bharatpur, Rajasthan</span>
          <span className={styles.rule} />
        </motion.div>

        {/* Main heading */}
        <motion.h1
          className={styles.heading}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.65, ease: [0.16, 1, 0.3, 1] }}
        >
          Bharatpur's Most
          <br />
          <em>Beloved</em> Salon
        </motion.h1>

        {/* Subtext */}
        <motion.p
          className={styles.sub}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.85 }}
        >
          Where every woman leaves more beautiful than she arrived.
        </motion.p>

        {/* CTAs */}
        <motion.div
          className={styles.ctas}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.05 }}
        >
          <a href={WA} target="_blank" rel="noopener noreferrer" className={styles.btnPrimary}>
            Book Your Appointment →
          </a>
          <a href="#gallery" className={styles.btnGhost}>
            View Our Work ↓
          </a>
        </motion.div>

        {/* Rating pill */}
        <motion.div
          className={styles.ratingPill}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.3 }}
        >
          <span className={styles.stars}>★★★★★</span>
          <span>4.8 on Google &amp; Justdial</span>
        </motion.div>
      </div>

      {/* Scroll cue */}
      <motion.div
        className={styles.scrollCue}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6, duration: 0.8 }}
        aria-hidden="true"
      >
        <span className={styles.scrollLine} />
        <span className={styles.scrollLabel}>Scroll</span>
      </motion.div>
    </section>
  );
}
